export const SERVERS_TABLE_ACTIONS = {
  view: 'view',
  delete: 'delete',
} as const;

export const DEFAULT_SERVERS_PAGINATION_SETTINGS = {
  page: 1,
  pageSize: 25,
  ordering: 'name',
};

export const DEFAULT_SERVER_HISTORY_PAGINATION_SETTINGS = {
  page: 1,
  pageSize: 25,
  ordering: '-created',
};

export const MCP_SERVER_SETTINGS_PERMISSION_KEY =
  'mcp_servers_section.mcp_server_configuration';

export const MCP_DEVELOPER_DOCS_URL =
  'https://developer.kizen.com/docs/developers/build-with-the-mcp/connect-an-ai-assistant';

export const getSharingLabels = (t: (key: string) => string) => ({
  all: { view: t('VIEW/USE') },
  specific: { view: t('View/Use') },
});
